import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "../../common/Button/index.js";
import { deliveryTypes } from "./Constant.js";
import Modal from "react-bootstrap/Modal";
import "./Style.css";

function ViewReportDelivery({modalShow, handleShow, data, organizations}) {
    const [isFAX, setIsFAX] = useState(false);
    const [isHL7, setIsHL7] = useState(false);

  useEffect(() => {
    setIsFAX(data.type === "FAX");
    setIsHL7(data.type === "HL7");
  }, [data]);

  const deliveryTypeLabel = deliveryTypes.find((t) => t.value === data.type)?.label || data.type || " - ";

  return     (
  <Modal
      backdropClassName
      backdrop={"static"}
      show={modalShow}
      onHide={handleShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Report Delivery Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
      { organizations.length > 1 &&
            <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
              <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Organization<span style={{ color: "red" }}> *</span>{" "}
                </label>
              </Col>
              <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectLabel">{organizations.find(org => org.value === data?.orgId)?.label || " - "}</label>
              </Col>
            </Row>
        }
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Delivery Name<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.name || " - "}</label>
            </Col>
        </Row>
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Delivery Type<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{deliveryTypeLabel}</label>
            </Col>
        </Row>
        {!isFAX && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  Protocol<span style={{ color: "red" }}> </span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.protocol || " - "}</label>
            </Col>
        </Row>}
        {isHL7 && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  HL7 Template<span style={{ color: "red" }}> </span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.template || " - "}</label>
            </Col>
        </Row>}
        {!isFAX && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Host Name<span style={{ color: "red" }}> </span>{" "}
            </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.hostName || " - "}</label>
          </Col>
        </Row>}
        {isHL7 && <>
          <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
            <Col xs={12} sm={12} md={3} lg={3}>
              <label className="searchSelectLabel">
                Local Certificate ARN<span style={{ color: "red" }}> </span>{" "}
              </label>
            </Col>
            <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.localCertificateArn || " - "}</label>
            </Col>
          </Row>
          <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
            <Col xs={12} sm={12} md={3} lg={3}>
              <label className="searchSelectLabel">
                Remote Certificate ARN<span style={{ color: "red" }}> </span>{" "}
              </label>
            </Col>
            <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
              <label className="searchSelectedLabel">{data.remoteCertificateArn || " - "}</label>
            </Col>
          </Row>
        </>}
        {!isFAX && !isHL7 && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Username<span style={{ color: "red" }}> </span>{" "}
            </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
          <label className="searchSelectedLabel">{data.userName || " - "}</label>
          </Col>
        </Row>}
        {!isFAX && !isHL7 && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Secret<span style={{ color: "red" }}> </span>{" "}
            </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.secret?.substring(0,8).replaceAll(/./g, '*') || " - "}</label>
          </Col>
        </Row>}
        {!isHL7 && <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
            <label className="searchSelectLabel">
              Target<span style={{ color: "red" }}> *</span>{" "}
            </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">{data.target || " - "}</label>
          </Col>
        </Row>}
        <Row style = {{marginBottom:'20px', marginTop: '20px'}}>
          <Col xs={12} sm={12} md={3} lg={3}>
                <label className="searchSelectLabel">
                  File Type<span style={{ color: "red" }}> *</span>{" "}
                </label>
          </Col>
          <Col xs={12} sm={12} md={9} lg={9} style={{ overflow: "hidden", wordWrap: "break-word" }}>
            <label className="searchSelectedLabel">
              {(Array.isArray(data.fileType)
                ? data.fileType.join(", ")
                : data.fileType) || " - "}
            </label>
          </Col>
        </Row>
        <Row>
          <Col>
          <Button style={{marginRight: "20px"}}
              onClick={() => {
                  handleShow();
              }}
              variant="secondary"
              title="Close">Close</Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default ViewReportDelivery;
